































































































































































































































































  import { Button, Form, Field, PullRefresh,Overlay,Toast,Popup,List, Dialog,Checkbox, CheckboxGroup, Loading } from "vant";
  import { formatDate } from "@/utils/date";
  export default {
    components: {
      [Button.name]: Button,
      [Form.name]: Form,
      [Field.name]: Field,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Popup.name]: Popup,
      [List.name]: List,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Loading.name]: Loading,
    },
    data() {
      return {
        accountAll:[],
        cancel_reqs:[],

        overlayShow: false,
        refreshing: false,
        loading: false,
        finished: false,
        tableData:[],
        totalNum:0,
        parentParem:{
            size:10,
            page:0,
        },

        sonLoading: false,
        sonFinished: false,
        sonTableData:{
            fields:[],
            list:[]
        },
        sonTotalNum:0,
        queryParem:{
            order_lz_id:'',
            current_page:0,
            page_size:10,
            account_no:''
        },
        isLoadList:false,

        dialogShow:false,
        dialogText:'',
        dialogType:1,  // 1-账户撤单 2-批量撤单
        curRowData:{},
        isSubmit:false,
        issSonScroll:false,

        cancellationConfirmationChecked : false, // 撤单确认开关状态
        noRemindersChecked: false, // 勾选“不再提醒”
        cancellationLoading: false,

		account_all_no:[]

      };
    },
    computed:{
        fieldData(){
            return (this as any).sonTableData.fields.map(item =>{
                return item.keyId
            })
        }
    },
    filters:{
        dateStr(val){
            if(val){
                return formatDate(new Date(val*1000), "MM/dd hh:mm:ss");
            }else{
                return '-'
            }
        },
        timeStr(val){
            return formatDate(new Date(val), "hh:mm:ss");
        },
        orderStatus(val){
            let str = ''
            if(val === 54 || val === 49 || val === 52){
                str = 'color: #02AA39;'
            }else if(val === 55 || val === 56 || val === 50 || val === 51){
                str = 'color: #F69500;'
            }else if(val === 53 || val === 68){
                str = 'color: #333999;'
            }else{
                str = 'color: #FF9275'
            }
            return str
        }

    },
    async created(){
        await (this as any).onLoad();
		Toast.resetDefaultOptions();
		(this as any).getGroup();
		sessionStorage.removeItem('xid')
      // (this as any).getTradeSettings(); // 初次渲染，查询用户设置状态。
      // (this as any).updateToken();
      // (this as any).updateTokenRegularly(120000); // 需求变更：不在轮询
    },
    methods: {

		getGroup(){
			(this as any).account_all_no = [];
			(this as any).$apis.getGroupList({show_account:1,is_empty_hide:1}).then(res =>{
				res.forEach(item =>{
					item.account_list.forEach(items =>{
						(this as any).account_all_no.push(items)
					})
				})
			})
		},

        tableScroll(e){
            if((this as any).$refs['tableList'].scrollLeft == 0){
                //滚动至最左边触发
                
                (this as any).issSonScroll = false;
                // (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
                //     item.style.width = 'calc(100vw - '+40+'px)';
                // })
            } else if((this as any).$refs['tableList'].scrollLeft > ((this as any).$refs['tableList'].scrollWidth - (this as any).$refs['tableList'].clientWidth - 10)){
                //滚动至最右边触发
                
                (this as any).issSonScroll = true;
                // (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
                //     // let num = (this as any).$refs['tableList'].scrollLeft - 40;
                //     item.style.width = 'calc(100% - 20px)';
                // })
            } else{
                //没有任何一边达到顶端
                
                (this as any).issSonScroll = true;
                // (this as any).$refs['tableList'].querySelectorAll('.item-option').forEach(item=>{
                //     let num = (this as any).$refs['tableList'].scrollLeft + (this as any).$refs['tableList'].clientWidth - 20;
                //     item.style.width = ''+num+'px';
                // })
            }

        },
        dialogTab(type,row){
		  (this as any).getTradeSettings();
		  if(!(this as any).cancellationConfirmationChecked){
		      (this as any).directCancellation(type,row);
		      return
		  }
		    switch (type) {
		      case 1:
		        (this as any).dialogText = '您确定要撤销本次未成委托？'
		        break;
		      case 2:
		        (this as any).dialogText = '您确定要撤销所有账户未成委托？'
		        break;
		      case 3:
		        (this as any).dialogText = '您确定要撤销该母单未成委托？'
		        break;
		      default:
		        break;
		    }
		    (this as any).dialogType = type;
		    (this as any).dialogShow = true;
		    (this as any).curRowData = row;


          // (this as any).getTradeSettings().then(()=>{
          //   // 撤单确认窗口的开关状态-已关闭
          //   if(!(this as any).cancellationConfirmationChecked){
          //     (this as any).directCancellation(type,row);
          //     return
          //   }

          //   switch (type) {
          //     case 1:
          //       (this as any).dialogText = '您确定要撤销本次未成委托？'
          //       break;
          //     case 2:
          //       (this as any).dialogText = '您确定要撤销所有账户未成委托？'
          //       break;
          //     case 3:
          //       (this as any).dialogText = '您确定要撤销该母单未成委托？'
          //       break;
          //     default:
          //       break;
          //   }
          //   (this as any).dialogType = type;
          //   (this as any).dialogShow = true;
          //   (this as any).curRowData = row;
          // });
        },
        popupTab(){
          // 用户勾选“下次不在提醒”的处理
          (this as any).handleNoReminderProcess();

            (this as any).dialogShow = false;
            (this as any).noRemindersChecked = false;
            (this as any).batchcancel((this as any).dialogType,(this as any).curRowData)

        },
        closePopup(){
            (this as any).queryParem.current_page = 0;
            (this as any).sonTotalNum = 0;
            (this as any).sonTableData.list = [];
            if((this as any).isLoadList){
                (this as any).refreshing = true;
                (this as any).onRefresh();
            }
        },
        batchcancel(cancel_type,row = {}){
            let parmes = {}
            if(cancel_type == 2){
                parmes = {
                    cancel_type,
                    isall:true,
					account_no:(this as any).account_all_no
                    // auto_ids:(this as any).accountAll
                }
            }else if(cancel_type == 1){
                const { account_no,client_order_no,order_side,order_price,order_qty,goods_code,goods_name,order_no }:any = row
                parmes = {
                    cancel_type,
                    cancel_reqs:[{
                        account_no,client_order_no,server_flag:1,

                        order_side,
                        order_price,
                        order_qty,
                        goods_code,
                        goods_name,
                        order_no
                    }]
                }
            }else if(cancel_type == 3){
                const { auto_id }:any = row
                parmes = {
                    cancel_type:1,
                    auto_ids:[auto_id]
                }
            }
            (this as any).cancellationLoading = true;
            (this as any).$apis
            .batchcancel(parmes)
            .then(res => {
              (this as any).cancellationLoading = false;
              Toast({
                message: '订单已提交，请关注订单状态',
                overlay: true,
                closeOnClickOverlay: true,
                duration: 3000,
              });
                // Dialog({ title: '',message: '撤单成功' }).then(()=>{
                    if(cancel_type == 2 || cancel_type == 3){
                        (this as any).refreshing = true;
                        (this as any).onRefresh();
                    }else if(cancel_type == 1){
                        (this as any).overlayShow = false;
                        (this as any).isLoadList = true;
                        (this as any).queryParem.current_page = 0;
                        (this as any).sonTotalNum = 0;
                        (this as any).sonTableData.list = [];
                        (this as any).onLoadSon();
                    }
                // });

            })
            .catch(e => {
              (this as any).cancellationLoading = false;
              Toast({
                message: `提交失败，${e.error_msg}，请重试`,
                overlay:true,
                closeOnClickOverlay: true,
                duration: 3000,
              });
                
            });
        },
        async onLoad() {
            setTimeout(() => {
                if ((this as any).refreshing) {
                    (this as any).finished = false;
                    (this as any).parentParem.page = 0;
                    (this as any).totalNum = 0;
                    (this as any).tableData = [];
                    (this as any).refreshing = false;
                    (this as any).accountAll = [];
                    (this as any).isLoadList = false;
                }
                (this as any).loading = true;
                (this as any).parentParem.page++;
                (this as any).getList();
                (this as any).loading = false;
                (this as any).refreshing = false;
            },1000)

        },
        onRefresh() {
            setTimeout(() => {
                Toast('刷新成功');
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                (this as any).loading = true;
                (this as any).onLoad();
            }, 1000);
        },
        getList(){
            // 获取新列表之前，需要重置“所有账户撤单”按钮的判断条件
            (this as any).isSubmit = false;

            (this as any).$apis
            .queryparentorderlist((this as any).parentParem)
            .then(res => {
                 //   在成功获取列表的时候,增加token时间
                (this as any).updateToken();
                (this as any).totalNum = res.data.total;
                let q = res.data.parent_orders.map(item => {
                    return item.symbol
                }).join(',');
                (this as any).$apis.getContractInfo({symbol:q, isExpired: 2}).then(obj => {
                    res.data.parent_orders && res.data.parent_orders.forEach(item => {
                        let contract_info = obj.data.contract_info && obj.data.contract_info.find(val => val.symbol === item.symbol);
                        if(contract_info){
                            item.order_price = item.order_price.toFixed(contract_info.digits);
                        }
                        if(item.status !== 2){
                            (this as any).isSubmit = true
                        }
                        (this as any).accountAll.push(item.auto_ids)
                        let isgo = false;
                        let order_status = item.order_status
                        if(order_status === 48 || order_status === 49 || order_status === 50 || order_status === 51
                        || order_status === 52 || order_status === 53){
                            isgo = true;
                        }
                        item.isgo = isgo;
                        (this as any).tableData.push(item)
                    });
                    
                    
                    if ((this as any).tableData.length >= (this as any).totalNum) {
                        (this as any).finished = true;
                    }
                });


            })
            .catch(e => {
                
            });
        },
        viewSonList(row){
            (this as any).overlayShow = true;
            (this as any).queryParem.order_lz_id = row.auto_id;
            (this as any).queryParem.account_no = row.account_no;
            (this as any).queryParem.current_page = 0;
            (this as any).sonTotalNum = 0;
            (this as any).sonTableData.list = [];
            (this as any).onLoadSon()
        },

        //子单
        onLoadSon() {
            // if ((this as any).refreshing) {
            //     (this as any).queryParem.current_page = 0;
            //     (this as any).sonTotalNum = 0;
            //     (this as any).sonTableData.list = [];
            //     (this as any).refreshing = false;
            // }
            (this as any).queryParem.current_page++
            (this as any).getSonList();
            (this as any).sonLoading = false;

            if ((this as any).sonTableData.list.length >= (this as any).sonTotalNum) {
                (this as any).sonFinished = true;
            }
        },
        getSonList(){
            (this as any).$apis
            .querygrouporders((this as any).queryParem)
            .then(res => {
                (this as any).sonTotalNum = res.data.total;

                //  前端增加order_trade_direction订单交易方向, 买/卖
                for(let [index,item] of res.data.fields.entries()){
                  if(item.keyId == "order_trade_qty"){
                    
                    res.data.fields.splice(index,0,{keyId:"order_trade_direction",name:"方向"})
                    break;
                  }
                }

                (this as any).sonTableData.fields = res.data.fields;
                let q = res.data.group_order_infos.map(item => {
                    return item.symbol
                }).join(',');
                (this as any).$apis
                .getContractInfo({symbol:q}).then(obj => {
                    res.data.group_order_infos.forEach(item => {
                        let isgo = false;
                        let order_status = item.order_status
                        if(order_status === 48 || order_status === 49 || order_status === 50 || order_status === 51
                        || order_status === 52 || order_status === 53 || order_status === 56){
                            isgo = true;
                        }
                        item.isgo = isgo;
                        item.digits = null;
                        let contract_info = obj.data.contract_info && obj.data.contract_info.find(val => val.symbol === item.symbol);
                        if(contract_info){
                            item.digits = contract_info.digits;
                        }
                        if(item.isgo){
                            let obj = JSON.parse(JSON.stringify(item));
                            obj.isgo = false;
                            (this as any).sonTableData.list.push(obj,item);
                        }else{
                            (this as any).sonTableData.list.push(item);
                        }
                        // (this as any).sonTableData.list.push(item)
                        
                    });
                });

            })
            .catch(e => {
                
            });
        },
      // 获取用户的交易设置状态
      getTradeSettings() {
        
		(this as any).cancellationConfirmationChecked = Boolean((this as any).$localstorage.get("openObj").cancel_order);
		// 
        // return (this as any).$apis
        //     .getTransactionSettingList({})
        //     .then(res => {
        //       
        //       // 撤单确认
        //       (this as any).cancellationConfirmationChecked = Boolean(res.cancel_order);
        //     })
        //     .catch(e => {
        //       
        //     });
      },
      // 设置用户的交易设置
      setTradeSetting() {
        // 撤单确认
        let cancelOrder = Number((this as any).cancellationConfirmationChecked);
        (this as any).$apis
            .setTransactionSetting({
              cancel_order: cancelOrder,
            })
            .then(res => {
              
            })
            .catch(e => {
              
            });
      },
      // 勾选下次不在提醒的处理函数
      handleNoReminderProcess() {
          if((this as any).noRemindersChecked){
            (this as any).cancellationConfirmationChecked = false;
            (this as any).setTradeSetting()
          }
      },
      // 勾选不再提醒的情况下直接撤单的处理函数
      directCancellation(type,row) {
        
        (this as any).dialogType = type;
        (this as any).curRowData = row;
        (this as any).popupTab();
      },
      // 更新token时长接口
      updateToken(){
        (this as any).$apis
            .addTokenTime()
            .then(res => {
              
            })
            .catch(e => {
              
            });
      },
      // 在订单执行页面，轮询 更新token时长接口
      updateTokenRegularly(timeMs){
        setInterval(() => {
          
          this.updateToken();
        },timeMs)
      },
      orderPriceIsZero(value) {
        if (typeof value != "number" && typeof value != "string") {
          return value
        }

        const valueToNumber = Number(value);
        if (!isNaN(valueToNumber) && valueToNumber === 0) {
          return "--";
        } else {
          return value;
        }
      }
    }
  };
  